module.exports = __webpack_public_path__ + "static/media/versions-icon-green.43cd4f3b.svg";